import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import toast from 'react-hot-toast';
import { useAuth } from '../../context/AuthContext';


export default function CompanySetupPage() {
  const { user, refreshUser } = useAuth();
  const navigate = useNavigate();

  // ── Determina se l'azienda esiste già ──────────────────────────────────────
  const existingCompany = user?.company;
  const isFirstAccess = !existingCompany;

  // ── Inizializza il form con i dati già salvati (se esistono) ───────────────
  const [form, setForm] = useState({
    name:       existingCompany?.name       || '',
    vatNumber:  existingCompany?.vatNumber  || '',
    sector:     existingCompany?.sector     || '',
    size:       existingCompany?.size       || '',
    city:       existingCompany?.city       || '',
    website:    existingCompany?.website    || '',
  });

  const [editing, setEditing] = useState(isFirstAccess); // primo accesso → subito editabile
  const [loading, setLoading] = useState(false);

  const set = (k) => (e) => setForm(f => ({ ...f, [k]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name) { toast.error('Nome azienda obbligatorio'); return; }
    setLoading(true);
    try {
      await axios.post('/api/auth/company', form);
      await refreshUser();
      toast.success('Profilo aziendale salvato!');
      setEditing(false);
      if (isFirstAccess) navigate('/dashboard');
    } catch (err) {
      toast.error(err.response?.data?.message || 'Errore nel salvataggio');
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    // Ripristina i valori originali e torna in sola lettura
    setForm({
      name:      existingCompany?.name      || '',
      vatNumber: existingCompany?.vatNumber || '',
      sector:    existingCompany?.sector    || '',
      size:      existingCompany?.size      || '',
      city:      existingCompany?.city      || '',
      website:   existingCompany?.website   || '',
    });
    setEditing(false);
  };

  return (
    <div className="auth-page" style={{ alignItems: 'center', paddingTop: 10,  flexDirection: 'column' }}>
       {//Aggiunge il tasto torna a dashboard se non è il primo accesso
       !isFirstAccess && (
          <div style={{ width: '100%', maxWidth: 560, marginBottom: 12 }}>
            <Link
              to="/dashboard"
              style={{ fontSize: 14, color: '#1D9E75', display: 'inline-flex', alignItems: 'center', gap: 6 }}
            >
              ← Torna alla dashboard
            </Link>
          </div>
       )}
      <div style={{ background: 'white', border: '1px solid #E0DED6', borderRadius: 16, padding: '36px 32px', width: '100%', maxWidth: 560 }}>

        {/* Header */}
        <div style={{ marginBottom: 28, display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
          <div>
            <div style={{ fontSize: 11, fontWeight: 600, color: '#1D9E75', letterSpacing: '.08em', textTransform: 'uppercase', marginBottom: 6 }}>
              {isFirstAccess ? 'Primo accesso' : 'Profilo aziendale'}
            </div>
            <h1 style={{ fontSize: 22, marginBottom: 6 }}>
              {isFirstAccess ? 'Completa il profilo aziendale' : existingCompany?.name}
            </h1>
            <p style={{ color: '#5C5B55', fontSize: 14 }}>
              {isFirstAccess
                ? 'Queste informazioni serviranno per emettere il certificato ESG. Puoi modificarle in seguito.'
                : 'Informazioni aziendali associate al tuo account.'}
            </p>
          </div>
          {/* Bottone Modifica — visibile solo quando non si è in modalità edit */}
          {!isFirstAccess && !editing && (
            <button
              className="btn btn-outline btn-sm"
              style={{ flexShrink: 0, marginLeft: 16, marginTop: 4 }}
              onClick={() => setEditing(true)}
            >
              ✏️ Modifica
            </button>
          )}
        </div>

        <form onSubmit={handleSubmit}>
          {/* Nome azienda */}
          <div className="form-group">
            <label>Nome azienda *</label>
            {editing ? (
              <input className="form-control" required placeholder="Acme Software S.r.l." value={form.name} onChange={set('name')} />
            ) : (
              <ReadOnlyField value={form.name} />
            )}
          </div>

          {/* Partita IVA + Città */}
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
            <div className="form-group">
              <label>Partita IVA</label>
              {editing ? (
                <input className="form-control" placeholder="IT12345678901" value={form.vatNumber} onChange={set('vatNumber')} />
              ) : (
                <ReadOnlyField value={form.vatNumber} />
              )}
            </div>
            <div className="form-group">
              <label>Città</label>
              {editing ? (
                <input className="form-control" placeholder="Milano" value={form.city} onChange={set('city')} />
              ) : (
                <ReadOnlyField value={form.city} />
              )}
            </div>
          </div>

          {/* Settore + Dimensione */}
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
            <div className="form-group">
              <label>Settore</label>
              {editing ? (
                <select className="form-control" value={form.sector} onChange={set('sector')}>
                  <option value="">Seleziona...</option>
                  <option>Software / SaaS</option>
                  <option>Fintech</option>
                  <option>Healthtech</option>
                  <option>E-commerce</option>
                  <option>ERP / Gestionali</option>
                  <option>Altro</option>
                </select>
              ) : (
                <ReadOnlyField value={form.sector} />
              )}
            </div>
            <div className="form-group">
              <label>Dimensione</label>
              {editing ? (
                <select className="form-control" value={form.size} onChange={set('size')}>
                  <option value="">Seleziona...</option>
                  <option value="micro">Micro (1–9 dip.)</option>
                  <option value="small">Piccola (10–49 dip.)</option>
                  <option value="medium">Media (50–249 dip.)</option>
                  <option value="large">Grande (250+ dip.)</option>
                </select>
              ) : (
                <ReadOnlyField value={SIZE_LABELS[form.size] || form.size} />
              )}
            </div>
          </div>

          {/* Sito web */}
          <div className="form-group">
            <label>Sito web</label>
            {editing ? (
              <input className="form-control" placeholder="https://www.azienda.it" value={form.website} onChange={set('website')} />
            ) : (
              <ReadOnlyField value={form.website} isLink />
            )}
          </div>

          {/* Bottoni azione */}
          {editing && (
            <div style={{ display: 'flex', gap: 10, marginTop: 8 }}>
              {!isFirstAccess && (
                <button type="button" className="btn btn-outline" onClick={handleCancel}>
                  Annulla
                </button>
              )}
              <button
                className="btn btn-primary btn-lg"
                style={{ flex: 1, justifyContent: 'center' }}
                disabled={loading}
              >
                {loading ? 'Salvataggio...' : isFirstAccess ? 'Salva e continua →' : 'Salva modifiche'}
              </button>
            </div>
          )}
        </form>
      </div>
    </div>
  );
}

// ── Componente campo in sola lettura ────────────────────────────────────────
function ReadOnlyField({ value, isLink = false }) {
  const displayValue = value || '—';
  return (
    <div style={{
      padding: '9px 12px',
      background: '#F8F8F6',
      border: '1px solid #E0DED6',
      borderRadius: 8,
      fontSize: 14,
      color: value ? '#1A1A18' : '#9B9A92',
      minHeight: 38,
    }}>
      {isLink && value ? (
        <a href={value} target="_blank" rel="noopener noreferrer" style={{ color: '#1D9E75' }}>
          {value}
        </a>
      ) : (
        displayValue
      )}
    </div>
  );
}

// Mappa i valori enum ai label leggibili
const SIZE_LABELS = {
  micro:  'Micro (1–9 dip.)',
  small:  'Piccola (10–49 dip.)',
  medium: 'Media (50–249 dip.)',
  large:  'Grande (250+ dip.)',
};
